import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getBanners } from '../../actions/bannersActions';
import ReactGA from 'react-ga';
import PremiumFeature from './PremiumFeature';

class Advertisement extends Component {
  componentDidMount() {
    const { bannersGet } = this.props;

    bannersGet();
  }

  render() {
    const { image, redirectUrl, isTrial } = this.props;
    const trialUrl = `${process.env.S3_ASSETS_URL}/banners/banner_trial.png`;
    const imageUrl = image ? `${process.env.S3_ASSETS_URL}/banners/${image}` : '';
    const imageLink = isTrial ? trialUrl : imageUrl;
    const premiumBannerUrl = `${process.env.S3_ASSETS_URL}/banners/banner_premium.png`;

    return (
      <PremiumFeature premiumComponent={ <img alt={ 'advert' } className={ 'advertisement__image' } src={ premiumBannerUrl } /> }
        regularComponent={ <ReactGA.OutboundLink eventLabel={ `advertBannerClick-${redirectUrl}` }
          target='_blank'
          to={ redirectUrl }>
          <img alt={ 'advert' } className={ 'advertisement__image' } src={ imageLink } />
        </ReactGA.OutboundLink> } />

    );
  }
}

Advertisement.propTypes = {
  bannersGet: PropTypes.func,
  image: PropTypes.string,
  isTrial: PropTypes.bool.isRequired,
  redirectUrl: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    image: state.getIn(['banners', 'data', 'name']),
    redirectUrl: state.getIn(['banners', 'data', 'redirectUrl']),
    isTrial: state.getIn(['currentUser', 'data', 'trialEndsAt']) === null
  };
};

const mapDispatchToProps = {
  bannersGet: () => getBanners()
};

export default connect(mapStateToProps, mapDispatchToProps)(Advertisement);



// WEBPACK FOOTER //
// ./app/components/shared/_advertisement.jsx